import { useSelector } from 'react-redux';

export function useFeatureFlag(featureFlagName, defaultValue = false, checkIfEnabled = false) {
  const { flags } = useSelector((state) => state.featureFlags);

  return checkIfEnabled
    ? isFeatureFlagEnabled(flags, featureFlagName, !!defaultValue)
    : getFeatureFlagValue(flags, featureFlagName, defaultValue);
}

export function getFeatureFlagValue(flags, featureFlagName, defaultValue = false) {
  if (!flags.hasOwnProperty(featureFlagName)) {
    return defaultValue;
  }

  if (typeof flags[featureFlagName] === 'object') {
    return flags[featureFlagName].value;
  } else {
    return flags[featureFlagName];
  }
}

export function isFeatureFlagEnabled(flags, featureFlagName, defaultValue = false) {
  if (!flags.hasOwnProperty(featureFlagName)) {
    return defaultValue;
  }

  if (typeof flags[featureFlagName] === 'object') {
    return flags[featureFlagName].enabled;
  } else {
    return flags[featureFlagName];
  }
}
